module.exports = __webpack_public_path__ + "img/Team-Wilde-Pracht-1100.b3ba3391.jpg";